import { useEffect, useState } from "react";
import { Row, Button } from "react-bootstrap";
// contexts
import { useUser } from "contexts/UserContext";
// utils
import queryBusinessAnalyticsInfo from "services/queryBusinessAnalyticsInfo";
// components
import InviteModalNext from "../../../invite-others/invite-modal-next";
import { ReactComponent as IconCancelledSession } from "assets/svg/icon-cancelled-session.svg";
import { ReactComponent as OutlineCalendar } from "assets/svg/outline-calendar-2.svg";
import { ReactComponent as IconUpcoming } from "assets/svg/icon-upcoming.svg";
import { ReactComponent as IconPatient } from "assets/svg/icon-patient.svg";
import BreakdownBlock from "./breakdown-block";
// styles
import styles from "./styles.module.scss";

const SessionsOutlook = ({ isInDashboardHome }) => {
  const { user } = useUser();
  const [, setError] = useState("");
  const [businessInfo, setBusinessInfo] = useState({
    patients: 0,
    sessions_completed: 0,
    upcoming_sessions: 0,
    cancelled_sessions: 0,
  });

  const [showInviteModal, setShowInviteModal] = useState(false);

  // get business analytics data on init
  useEffect(() => {
    if (!user?.sub) {
      return;
    }
    queryBusinessAnalyticsInfo()
      .then((res) => {
        setBusinessInfo(res);
      })
      .catch((err) => {
        setError(err);
      });
  }, [user?.sub]);

  return (
    <Row>
      <BreakdownBlock general={true} isInDashboardHome={isInDashboardHome}>
        <IconPatient color={`var(--blue)`} />
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-num"]
              : styles["breakdowns__col-num--ba-tab"]
          }
        >
          {businessInfo.patients}
        </div>
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-text"]
              : styles["breakdowns__col-text--ba-tab"]
          }
        >
          {businessInfo.patients === 0 ? (
            <>
              <Button
                variant="link"
                className={styles["breakdowns__col-button"]}
                onClick={() => setShowInviteModal(true)}
              >
                Invite a patient
              </Button>
              <InviteModalNext
                show={showInviteModal}
                onHide={() => setShowInviteModal(false)}
                invitee={"member"}
              />
            </>
          ) : (
            `Patients`
          )}
        </div>
      </BreakdownBlock>
      <BreakdownBlock general={true} isInDashboardHome={isInDashboardHome}>
        <OutlineCalendar color={`var(--blue)`} />
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-num"]
              : styles["breakdowns__col-num--ba-tab"]
          }
        >
          {businessInfo.sessions_completed}
        </div>
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-text"]
              : styles["breakdowns__col-text--ba-tab"]
          }
        >
          Sessions completed
        </div>
      </BreakdownBlock>
      <BreakdownBlock general={true} isInDashboardHome={isInDashboardHome}>
        <IconUpcoming color={`var(--blue)`} />
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-num"]
              : styles["breakdowns__col-num--ba-tab"]
          }
        >
          {businessInfo.upcoming_sessions}
        </div>
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-text"]
              : styles["breakdowns__col-text--ba-tab"]
          }
        >
          Upcoming sessions
        </div>
      </BreakdownBlock>
      <BreakdownBlock general={false} isInDashboardHome={isInDashboardHome}>
        <IconCancelledSession color={`var(--deep-orange)`} />
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-num"]
              : styles["breakdowns__col-num--ba-tab"]
          }
        >
          {businessInfo.cancelled_sessions}
        </div>
        <div
          className={
            isInDashboardHome
              ? styles["breakdowns__col-text"]
              : styles["breakdowns__col-text--ba-tab"]
          }
        >
          Cancelled sessions
        </div>
      </BreakdownBlock>
    </Row>
  );
};

export default SessionsOutlook;
